import { ROUTES } from '@dealstack/frontend/investor/pages/Routing/routes';
import { generatePath } from 'react-router-dom';

export enum INVESTMENT_ROUTES {
	JOIN_ALLOCATION = '/join',
	MANAGE = '/manage',
	LEAVE = '/leave',
}

/** Absolute URL of an investment flow; its step routes are appended to this. */
export const investmentFlowPath = (
	flow: INVESTMENT_ROUTES,
	params: { dealId: string; mipId: string; investmentWorkflowId: string }
): string => generatePath(`${ROUTES.INVESTMENT}${flow}`, params);
